import React from 'react';

function ContactList({ color = '#808080', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" {...props}>
            <path
                fill={color}
                d="M12 10.5a2.17 2.17 0 0 1-1.594-.656A2.17 2.17 0 0 1 9.75 8.25c0-.625.219-1.156.656-1.594A2.17 2.17 0 0 1 12 6a2.17 2.17 0 0 1 1.594.656c.437.438.656.969.656 1.594a2.17 2.17 0 0 1-.656 1.594A2.17 2.17 0 0 1 12 10.5ZM7.5 15v-1.425c0-.262.063-.512.188-.75.125-.237.3-.425.525-.563a6.957 6.957 0 0 1 1.79-.759A7.704 7.704 0 0 1 12 11.25c.7 0 1.366.084 1.997.253a6.958 6.958 0 0 1 1.79.76c.225.137.4.325.525.562.125.238.188.488.188.75V15h-9Zm1.613-1.5h5.774c-.437-.25-.9-.438-1.387-.563a6.015 6.015 0 0 0-1.5-.187c-.512 0-1.012.063-1.5.188-.488.124-.95.312-1.387.562ZM12 9c.213 0 .39-.072.534-.216a.726.726 0 0 0 .216-.534.726.726 0 0 0-.216-.534A.726.726 0 0 0 12 7.5a.726.726 0 0 0-.534.216.726.726 0 0 0-.216.534c0 .213.072.39.216.534A.726.726 0 0 0 12 9Zm-9.75 1.5V9h6v1.5h-6Zm0-6V3h9v1.5h-9Zm6.075 3H2.25V6H9a2.824 2.824 0 0 0-.422.694c-.106.25-.19.519-.253.806Z"
            />
        </svg>
    );
}

export default ContactList;
